import { render } from "./ImportFile.vue?vue&type=template&id=47d5052c&ts=true"
import script from "./ImportFile.vue?vue&type=script&lang=ts"
export * from "./ImportFile.vue?vue&type=script&lang=ts"

import "./ImportFile.vue?vue&type=style&index=0&id=47d5052c&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__